import api from './api';

const userService = {
  getProfile: async () => {
    try {
      const response = await api.get('/users/me');
      
      if (response.data.user) {
        localStorage.setItem('journi_user', JSON.stringify(response.data.user));
      }
      
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error?.message || 'Failed to fetch profile'
      };
    }
  },

  updateProfile: async (data) => {
    try {
      const formData = new URLSearchParams();
      if (data.name) formData.append('name', data.name);
      if (data.gender) formData.append('gender', data.gender);
      if (data.password) formData.append('password', data.password);

      const response = await api.put('/users/me', formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
      
      if (response.data.token) {
        localStorage.setItem('journi_token', response.data.token);
      }
      
      if (response.data.user) {
        localStorage.setItem('journi_user', JSON.stringify(response.data.user));
      }
      
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error?.message || 'Failed to update profile'
      };
    }
  }
};

export default userService;